import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  background: #151515;
  padding: 28px 10px 28px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 70px;

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(
      to bottom,
      rgba(21, 21, 21, 0) 0%,
      rgba(21, 21, 21, 1) 100%
    );
    pointer-events: none;
    z-index: 0;
  }
`;

const FooterItem = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120px;
    height: 120px;
    transform: translate(-50%, -50%);
    background: radial-gradient(
      circle,
      rgba(115, 84, 242, 0.4) 0%,
      rgba(115, 84, 242, 0) 70%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 1;
  }

  &:hover::before {
    opacity: 1;
  }
`;

const FooterItemRight = styled(FooterItem)`
  margin-left: auto;
`;

const FooterItemCenter = styled(FooterItem)`
  position: absolute;
  right: 50%;
  transform: translateX(50%);
  flex-direction: column;
`;

const FooterIconCaption = styled.p`
  color: #b4b4b4;
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  margin: 0;
`;

const FooterImage = styled.img`
  width: 38px;
  height: 18px;
  object-fit: contain;
`;

const FooterImageRight = styled(FooterImage)`
  transform: rotate(180deg);
`;

const FooterImageLeft = styled(FooterImage)``;

const FooterText = styled.span`
  color: #b4b4b4;
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
`;

const ScrollIcon = styled.img`
  width: clamp(16px, 5vw, 20px);
  height: clamp(32px, 8vh, 41px);
  display: block;
`;

const textAnimation = {
  hidden: {
    y: 50,
    opacity: 0,
  },
  visible: (custom: number) => ({
    y: 0,
    opacity: 1,
    transition: {
      delay: custom * 0.2,
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1],
    },
  }),
};
const AnimatedScrollIcon = motion(ScrollIcon);

interface FooterProps {
  textLeft?: string;
  textRight?: string;
  practica?: boolean;
  mainScreen?: boolean;
  mainScreenText?: string;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  handleDown?: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  textLeft,
  textRight,
  practica = false,
  mainScreen = false,
  mainScreenText,
  onSwipeLeft,
  onSwipeRight,
  handleDown,
}) => {
  return (
    <Wrapper>
      {textLeft && (
        <FooterItem onClick={onSwipeRight}>
          <FooterImageLeft
            src={
              practica ? '/assets/swipeleftpurple.svg' : '/assets/swipeleft.svg'
            }
          />
          <FooterText>{textLeft}</FooterText>
        </FooterItem>
      )}
      {mainScreen && (
        <FooterItemCenter onClick={handleDown}>
          <AnimatedScrollIcon
            src="/assets/scroll.svg"
            alt="Scroll indicator"
            variants={textAnimation}
            initial="hidden"
            animate="visible"
            custom={3}
          />
          <FooterIconCaption>{mainScreenText}</FooterIconCaption>
        </FooterItemCenter>
      )}
      {textRight && (
        <FooterItemRight onClick={onSwipeLeft}>
          <FooterText>{textRight}</FooterText>
          <FooterImageRight
            src={
              practica ? '/assets/swipeleftpurple.svg' : '/assets/swipeleft.svg'
            }
          />
        </FooterItemRight>
      )}
    </Wrapper>
  );
};
